module.exports = "https://cdn-challenge.mathletics.com/app/281/assets/fonts/1ac3ed6ebe34e473519ca1da86f7a384.woff2";